import React from 'react';
import { RecallsUnitedContent } from '../../pages/recalls-united/hooks/use-recalls-united-content';
import {
    RecallItems,
    RecallsApiResponse,
} from '../../../services/recalls-service/recalls-service';
import RecallsButton from '../recalls-button/recalls-button';
import { ToolTip } from '../../../components/common/tooltip/tooltip';
import './recalls-list.scss';
import { ExemptWordsListProps } from '../../pages/recalls/hook/use-exempt-word-list';
interface Props {
    content: RecallsUnitedContent;
    recallsData: RecallsApiResponse | null | undefined;
    exemptWordsList?: ExemptWordsListProps | null;
    handleShowRecall: (
        recall: RecallItems,
        showModal: boolean,
        isCsp: boolean
    ) => void;
    currentRecall?: RecallItems;
    showRecalls: boolean;
    showCsp: boolean;
}

const RecallsList = (props: Props) => {
    const {
        content,
        recallsData,
        exemptWordsList,
        handleShowRecall,
        currentRecall,
        showRecalls,
        showCsp,
    } = props;
    const recallsCount =
        (recallsData?.nhtsa?.length ?? 0) + (recallsData?.recalls?.length ?? 0);
    const cspCount = recallsData?.fsa?.length ?? 0;
    const areWarnings = recallsCount + cspCount > 0;
    return (
        <div
            className={`recalls-buttons-list-container${
                areWarnings ? '' : ' no-recalls-or-csp'
            }`}
        >
            {areWarnings ? (
                <>
                    {showRecalls && (
                        <>
                            <section className="recalls-buttons-list">
                                <header className="recalls-safety-heading">
                                    {content.safetyRecallsLabel}
                                    <ToolTip
                                        customDismissTooltipAriaLabel={
                                            content.closeDisclaimerAriaLabel
                                        }
                                        tooltipSymbol={
                                            content.recallsDisclaimerSymbol
                                        }
                                        tooltipContent={
                                            content.recallsDisclaimer
                                        }
                                        className="recalls-disclaimer-tooltip"
                                    />
                                </header>
                                {recallsCount > 0 ? (
                                    <div className="recalls-info-buttons">
                                        {(recallsData?.nhtsa?.length ?? 0) >
                                            0 &&
                                            recallsData?.nhtsa?.map(recall => {
                                                return (
                                                    <RecallsButton
                                                        recall={recall}
                                                        content={content}
                                                        onClick={
                                                            handleShowRecall
                                                        }
                                                        isCsp={false}
                                                        key={
                                                            recall.descriptionLang
                                                        }
                                                        exemptWordsList={
                                                            exemptWordsList
                                                        }
                                                        isSelected={
                                                            currentRecall?.nhtsaRecallNumber ===
                                                            recall.nhtsaRecallNumber
                                                        }
                                                    />
                                                );
                                            })}
                                        {(recallsData?.recalls?.length ?? 0) >
                                            0 &&
                                            recallsData?.recalls?.map(
                                                recall => {
                                                    return (
                                                        <RecallsButton
                                                            recall={recall}
                                                            content={content}
                                                            onClick={
                                                                handleShowRecall
                                                            }
                                                            isCsp={false}
                                                            key={
                                                                recall.descriptionLang
                                                            }
                                                            exemptWordsList={
                                                                exemptWordsList
                                                            }
                                                            isSelected={
                                                                currentRecall?.fsaNumber ===
                                                                recall.fsaNumber
                                                            }
                                                        />
                                                    );
                                                }
                                            )}
                                    </div>
                                ) : (
                                    <div className="no-recalls-message">
                                        {content.noRecallsMessage}
                                    </div>
                                )}
                            </section>
                        </>
                    )}

                    {showCsp && (
                        <>
                            <section className="csp-buttons-list">
                                <header className="recalls-safety-heading">
                                    {content.cspLabel}
                                    <ToolTip
                                        tooltipSymbol={
                                            content.cspDisclaimerSymbol
                                        }
                                        tooltipContent={content.cspDisclaimer}
                                        className="recalls-disclaimer-tooltip"
                                    />
                                </header>
                                {cspCount > 0 ? (
                                    <div className="recalls-info-buttons">
                                        {recallsData?.fsa?.map(csp => {
                                            return (
                                                <RecallsButton
                                                    recall={csp}
                                                    content={content}
                                                    onClick={handleShowRecall}
                                                    isCsp={true}
                                                    key={csp.descriptionLang}
                                                    exemptWordsList={
                                                        exemptWordsList
                                                    }
                                                    isSelected={
                                                        currentRecall?.fsaNumber ===
                                                        csp.fsaNumber
                                                    }
                                                />
                                            );
                                        })}
                                    </div>
                                ) : (
                                    <div className="no-recalls-message">
                                        {content.noCspMessage}
                                    </div>
                                )}
                            </section>
                        </>
                    )}
                </>
            ) : (
                <>
                    <div className="no-recalls-message">
                        {recallsData?.error
                            ? content.apiFailureErrorMessage
                            : content.noRecallNoCspMessage}
                    </div>
                </>
            )}
        </div>
    );
};

export default RecallsList;
